import { render, staticRenderFns } from "./CameraPermissionErrorDialog.vue?vue&type=template&id=2d4a6a38&scoped=true&"
import script from "./CameraPermissionErrorDialog.vue?vue&type=script&lang=ts&"
export * from "./CameraPermissionErrorDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4a6a38",
  null
  
)

export default component.exports